/**
 * Güvenli minimal Markdown → HTML dönüştürücü.
 *
 * Ham HTML çalıştırmayı engellemek için ÖNCE tüm `<` `>` `&` karakterlerini
 * kaçırırız (escape), SONRA yalnızca tanıdığımız markdown token'larını
 * güvenli HTML etiketlerine çevirir. Böylece kullanıcı içeriğine XSS payload
 * yerleştirse bile tarayıcıda çalıştırılmaz. `dangerouslySetInnerHTML` ile
 * kullanılırken güvenlidir.
 *
 * Desteklenen: # / ## / ### başlıklar, **kalın**, `inline code`,
 * numaralı liste (1. ...), madde işaretli liste (- ...), paragraf.
 */

const ESC_MAP = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

function escapeHtml(s) {
  return String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ESC_MAP[c]);
}

export function renderMarkdown(md) {
  let x = escapeHtml(md);
  x = x.replace(/^### (.+)$/gm, "<h3 class='text-base font-bold mt-3 mb-1 text-slate-100'>$1</h3>");
  x = x.replace(/^## (.+)$/gm, "<h2 class='text-lg font-bold mt-4 mb-2 text-blue-300'>$1</h2>");
  x = x.replace(/^# (.+)$/gm, "<h1 class='text-xl font-bold mt-4 mb-2 text-slate-50'>$1</h1>");
  x = x.replace(/\*\*(.+?)\*\*/g, "<b class='text-slate-100'>$1</b>");
  x = x.replace(/\*(?!\s)(.+?)(?<!\s)\*/g, "<i class='text-slate-200'>$1</i>");
  x = x.replace(/`([^`]+)`/g, "<code class='bg-slate-800 px-1 rounded text-blue-300'>$1</code>");
  x = x.replace(/^\d+\. (.+)$/gm, "<li class='ml-6 list-decimal'>$1</li>");
  x = x.replace(/^- (.+)$/gm, "<li class='ml-6 list-disc'>$1</li>");
  x = x.split("\n\n").map((p) => (p.trim().startsWith("<") ? p : `<p class='my-2'>${p}</p>`)).join("");
  return x;
}

/**
 * Bir route değerinin uygulama içi güvenli bir path olduğunu doğrular.
 * Reddedilenler: dış URL (http/https), scheme'li payload (javascript:, data:,
 * vbscript:, file:), protocol-relative (//host/...), boş/whitespace.
 */
export function isSafeInternalRoute(route) {
  if (typeof route !== "string") return false;
  const r = route.trim();
  if (!r) return false;
  if (!r.startsWith("/")) return false;
  if (r.startsWith("//")) return false;
  // Bilinen tehlikeli scheme kontrolü (baştaki `/` bunu zaten engelliyor ama
  // savunmanın çift katmanı olsun).
  if (/^[a-z0-9+.-]*:/i.test(r.replace(/^\/+/, ""))) return false;
  return true;
}
